import React, { useState, useContext } from 'react';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { DataContext } from '../../../../stores/covering-table-store';
import { DataContext as MainDataContext } from '../../../../store';

import CorruptAssignmentsTable from './CorruptAssignmentsTable';

const CorruptAssignmentsModal = ({ show, onHide, row }) => {
    // ------- DataContext -------
    const { store } = useContext(DataContext);
    const { selectedDate: selectedCoveringDate, latestDate: latestCoveringDate } = store;
    const selectedCoveringDateString = moment(selectedCoveringDate).format('YYYY-MM-DD').toString();
    const latestCoveringDateString = moment(latestCoveringDate).format('YYYY-MM-DD').toString();
    const {
        store: { user },
    } = useContext(MainDataContext);

    // ------- States -------
    const [errorMessage, setErrorMessage] = useState('');
    const showErrorMessage = (msg) => setErrorMessage(msg);

    // ------- Fields -------
    const isAdmin = user.isAdmin;
    const isLatestBlgDate = selectedCoveringDateString === latestCoveringDateString;
    const isEditable = isAdmin && isLatestBlgDate;
    const corruptAssignments = row.assignments.filter((a) => a.isCorrupt);

    // ------- Component -------
    return (
        <Modal className='corrupt-assignments-modal' show={show} onHide={onHide} size='lg'>
            <Modal.Header className='d-flex flex-column'>
                <h3>Korrupta uppdrag för {row.empName}</h3>
                {!isAdmin && (
                    <div className='alert alert-warning' role='alert'>
                        I dagsläget har endast admin rättighet att redigera korrupta uppdrag. Vänligen maila{' '}
                        <a href='mailto:alltid@consid.se'>alltid@consid.se</a>.
                    </div>
                )}
                {isAdmin && !isLatestBlgDate && (
                    <div className='alert alert-warning' role='alert'>
                        I dagsläget kan bara det senaste beläggningsarket redigeras.
                    </div>
                )}
                {errorMessage && errorMessage.length > 0 && (
                    <div className='alert alert-danger alert-dismissible fade show' role='alert'>
                        {errorMessage}
                        <button type='button' className='close' data-dismiss='alert' onClick={() => setErrorMessage('')}>
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                )}
            </Modal.Header>
            <Modal.Body>
                <CorruptAssignmentsTable
                    empID={row.empID}
                    assignments={corruptAssignments}
                    isEditable={isEditable}
                    showErrorMessage={showErrorMessage}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={onHide}>
                    Stäng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CorruptAssignmentsModal;
